import { render } from "./oficialiaAdjuntos.vue?vue&type=template&id=89d138d0"
import script from "./oficialiaAdjuntos.vue?vue&type=script&lang=js"
export * from "./oficialiaAdjuntos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__